import { inject, Injectable } from '@angular/core';
import { AppService } from '@app/app.service';
import { AppHelper } from '@app/core/app.helper';
import { IMG_EXTENSIONS } from '@components/fields/file/constants/file.constants';
import { getDateTimeRuFormat } from 'src/shared/helpers/date-helpers';
import { InterfaceSettingsTable, InterfaceTableFileStruct } from '../../table.interface';

@Injectable()
export class TableCellsService {
    private readonly appService = inject(AppService);

    getSettingsTableFn: () => InterfaceSettingsTable = () => null;

    get settingsTable() {
        return this.getSettingsTableFn();
    }

    /**
     * Получение структуры файлов
     * @param rowElement строка с данными
     * @param id - ID поля
     */
    getFileCreate(rowElement: string | object, id: string) {
        if (!rowElement) {
            return '';
        }
        let valueArray = [];
        const result = [];
        if (typeof rowElement === 'object') {
            valueArray = Object.entries(rowElement);
        } else {
            try {
                valueArray = JSON.parse(rowElement);
            } catch (e) {
                valueArray = rowElement.split('{br}');
            }
        }
        if (valueArray.length > 0 && typeof rowElement === 'object') {
            valueArray.forEach(([key, val]) => {
                if (val && key) {
                    const data = {
                        val,
                        key,
                        id,
                    };
                    const structFile = this.prepareFileStruct(data);
                    result.push(structFile);
                }
            });
        } else {
            valueArray.forEach((val) => {
                result.push(this.prepareFileStruct({ val, id }));
            });
        }
        return result.join(' ');
    }

    /**
     * Подготовка структуры файлов
     * @param data InterfaceTableFileStruct
     */
    prepareFileStruct(data: InterfaceTableFileStruct): string {
        const url = this.appService.settings.system_back_url + data.val.file_name;
        const urlExt = this.appService.serverUrl + data.val.file_name_ext;
        const urlExtPreview = this.appService.serverUrl + data.val.file_name_ext + '&p=1';
        const title = data.val?.caption?.[this.appService.currentLanguage];
        let image = '';
        if (this.isImageFromExtension(url)) {
            image = '<img src="' + urlExtPreview + '" alt="">';
        } else {
            if (
                this.settingsTable?.settings_nodes &&
                this.settingsTable?.settings_nodes[data.id] &&
                this.settingsTable?.settings_nodes[data.id].pdf_preview == '1' &&
                this.getExtension(url).toLowerCase() === 'pdf'
            ) {
                image = '<img src="' + urlExtPreview + '" alt="">';
            } else {
                image =
                    '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"' +
                    '     x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">' +
                    '    <path style="fill:#E2E5E7;"' +
                    '          d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"/>' +
                    '    <path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"/>' +
                    '    <polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "/>' +
                    '    <path class="color-document-svg"' +
                    '          d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,' +
                    '0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"/>' +
                    '    <text' +
                    '        style="font-size: 114px;text-align: center;font-weight: bold;fill:#ffffff;text-transform: uppercase;"' +
                    '        x="65" y="375">' +
                    this.getExtension(url) +
                    '    </text>' +
                    '    <path style="fill:#CAD1D8;"' +
                    '          d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"/>' +
                    '</svg>';
            }
        }
        let elem =
            '<div class="table-file-cell">' +
            '<a href="' +
            urlExt +
            '" class="image-preview-container' +
            (this.getExtension(url).toLowerCase() === 'pdf' ? ' pdf-preview-frame' : '') +
            '" target="_blank" title="' +
            (title ? title + '. ' : '') +
            data.val.name +
            '">' +
            image +
            '</a>';
        // Добавляем отображение данных файла
        if (this.settingsTable?.settings_nodes != null) {
            if (
                this.settingsTable?.settings_nodes[data.id] &&
                Number(this.settingsTable?.settings_nodes[data.id].is_show_file_info) === 1
            ) {
                elem += '<div class="file-info">';
                if (data.val?.name || title) {
                    elem += '<div>' + (title ?? data.val.name) + '</div> ';
                }
                if (data?.val?.size && Number(data.val.size) > 0) {
                    elem +=
                        '<div>' +
                        AppHelper.calcFileSize(data.val.size, 'Mb', 2) +
                        ' ' +
                        this.appService.language_dictionary.files_mb +
                        '</div> ';
                }
                if (data?.val?.download_date) {
                    elem += '<div>' + getDateTimeRuFormat(data.val.download_date) + '</div> ';
                }
                elem += '</div>';
            }
        } else {
            if (data.val?.name) {
                elem += '<div class="file-name">' + data.val.name + '</div>';
            }
        }
        elem += '</div>';
        return elem;
    }

    /**
     * Проверка картинка или нет файл из расширения
     */
    isImageFromExtension(file: any) {
        let ext = file.split('.');
        ext = ext[ext.length - 1];
        if (!ext) {
            return false;
        }
        ext = ext.toLowerCase();
        return IMG_EXTENSIONS.indexOf(ext) > -1;
    }

    /**
     * Получение расширения файла
     */
    getExtension(name: any) {
        // eslint-disable-next-line no-bitwise
        return name ? name.slice(((name.lastIndexOf('.') - 1) >>> 0) + 2) : null;
    }
}
